module.exports = __webpack_public_path__ + "static/media/ball-bright-close-up.90e44f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/ball-bright-close-up.jpg
// module id = 333
// module chunks = 0